// Game Controller - 游戏控制器
import { StateManager } from '../state';
import { ExplorationManager } from '../exploration';
import { ForbiddenManager } from '../forbidden';
import { CommandParser } from '../command-parser';
import { UtilsManager } from '../utils';

class GameController {
  constructor() {
    // 初始化各个管理器
    this.stateManager = new StateManager();
    this.explorationManager = new ExplorationManager(this.stateManager);
    this.forbiddenManager = new ForbiddenManager(this.stateManager);
    this.commandParser = new CommandParser(
      this.stateManager,
      this.explorationManager,
      this.forbiddenManager
    );
  }

  // 执行命令
  executeCommand(input) {
    try {
      return this.commandParser.parseCommand(input);
    } catch (error) {
      console.error('命令执行错误:', error);
      return [`命令执行失败：${error.message}`];
    }
  }

  // 获取游戏状态
  getGameState() {
    return this.stateManager.getState();
  }

  // 获取命令建议
  getCommandSuggestions(input) {
    return this.commandParser.getSuggestions(input);
  }

  // 重置游戏
  resetGame() {
    this.stateManager.resetState();
    // 重新初始化管理器
    this.explorationManager = new ExplorationManager(this.stateManager);
    this.forbiddenManager = new ForbiddenManager(this.stateManager);
    this.commandParser = new CommandParser(
      this.stateManager,
      this.explorationManager,
      this.forbiddenManager
    );
    return ['游戏已重置'];
  }

  // 保存游戏
  saveGame() {
    this.stateManager.saveState();
    return ['游戏已保存'];
  }

  // 获取游戏统计信息
  getGameStats() {
    const state = this.stateManager.getState();
    return {
      name: state.name,
      sect: state.sect,
      realm: state.realm,
      substage: state.substage,
      xp: state.xp,
      location: state.location,
      totalExplorations: state.totalExplorationCount || 0,
      totalDiscoveries: state.totalDiscoveries ? state.totalDiscoveries.length : 0,
      maxCompletion: state.maxExplorationCompletion || 0,
      inForbiddenMap: state.inForbiddenMap
    };
  }

  // 检查游戏状态
  isGameReady() {
    return this.stateManager.isNamed();
  }

  // 获取可用命令列表
  getAvailableCommands() {
    return this.commandParser.commandManager.getAvailableCommands();
  }
}

// 创建单例实例
const gameController = new GameController();

export default gameController;
